import { supabase } from '../lib/supabase';

const BUCKET = 'blog-images';
const MAX_BYTES = 5 * 1024 * 1024; // 5 MB

export interface UploadResult {
  publicUrl: string;
  path: string;
}

export async function uploadBlogImage(
  file: File,
  postId: string,
): Promise<UploadResult> {
  if (!file.type.startsWith('image/')) {
    throw new Error('Only image files are allowed.');
  }
  if (file.size > MAX_BYTES) {
    throw new Error('Image must be ≤ 5 MB.');
  }

  const ext = file.name.split('.').pop() ?? 'jpg';
  const uuid = crypto.randomUUID();
  const path = `${postId}/${uuid}.${ext}`;

  const { error: upErr } = await supabase.storage
    .from(BUCKET)
    .upload(path, file, { contentType: file.type, upsert: false });

  if (upErr) throw new Error(`Upload failed: ${upErr.message}`);

  const { data: urlData } = supabase.storage.from(BUCKET).getPublicUrl(path);
  const publicUrl = urlData.publicUrl;

  // Insert into blog_assets (non-fatal — don't block the caller)
  // Table schema: id, post_id, storage_key, public_url, alt, created_at
  await supabase.from('blog_assets').insert({
    post_id: postId,
    storage_key: path,
    public_url: publicUrl,
    alt: file.name,
  });

  return { publicUrl, path };
}
